import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SitesListComponent } from './sites-list/sites-list.component';
import { SitesHomeComponent } from './sites-home/sites-home.component';
import { SitesRoutingModule } from './sites-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { SitesMatTableMaintComponent } from './sites-mat-table-maint/sites-mat-table-maint.component';


@NgModule({
  declarations: [SitesListComponent, SitesHomeComponent, SitesMatTableMaintComponent],
  imports: [
    CommonModule,
    SharedModule,
    SitesRoutingModule
  ],
  exports: [SitesMatTableMaintComponent]
})
export class SitesModule { }
